// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  worldId: __t.u64().primaryKey().name("world_id"),
  owner: __t.identity(),
  name: __t.string(),
  kind: __t.string(),
  terrainSeed: __t.string().name("terrain_seed"),
  sizeM: __t.u32().name("size_m"),
  visibility: __t.string(),
  lifecycle: __t.string(),
  createdAt: __t.timestamp().name("created_at"),
});
